import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorsHttpService } from '@qaroni-core/services/commons/errors-http/errors-http.service';

@Component({
  selector: 'qaroni-errors-http-dialog',
  templateUrl: './errors-http-dialog.component.html',
  styleUrls: ['./errors-http-dialog.component.scss'],
  standalone: false,
})
export class ErrorsHttpDialogComponent {
  private errorsHttp = inject(ErrorsHttpService);
  dialogRef = inject<MatDialogRef<ErrorsHttpDialogComponent>>(MatDialogRef);
  error = inject<HttpErrorResponse>(MAT_DIALOG_DATA);

  public showErrorDetails: boolean = false;

  public onShowErrorDetails(): void {
    this.showErrorDetails = true;
  }

  public onCancelClick(): void {
    this.dialogRef.close(false);
  }

  get isControlledError(): boolean {
    return this.errorsHttp.isControlledError(this.error);
  }
}
